/**
 * Records the signed-in coach's NOVA open for today. Thin glue over
 * `~/lib/server/nova/opens`.
 *
 * Aliases: nova opened, nova usage, record nova visit
 */

import { createServerFn } from "@tanstack/react-start";

import { requireClerkCoachAuth } from "~/lib/coach-middleware";
import type { NovaOpenResult } from "~/lib/server/nova/opens";

/** Called from the NOVA layout's load; only her own visit writes. */
export const recordMyNovaOpen = createServerFn({ method: "POST" })
  .middleware([requireClerkCoachAuth])
  .handler(async ({ context }): Promise<NovaOpenResult> => {
    const { recordNovaOpened } = await import("~/lib/server/nova/opens");
    return recordNovaOpened(context.coach);
  });
